<template>
  <div>
    <c-page-section squares data-testid="note-record">
      <q-card>
        <q-card-section class="header">
          <div class="row items-center no-wrap">
            <div class="col">
              <div class="heading-bigger">
                {{ props.data.collaborator.name }}
                <span class="text-overline">{{
                  formatDateForTemplate({
                    date: props.data.createdAt,
                  })
                }}</span>
              </div>
            </div>
            <div class="col col-auto">
              <q-icon
                v-if="allowEdit"
                data-testid="edit-note"
                name="edit"
                color="grey"
                class="cursor-pointer q-pr-xs"
                size="sm"
                @click="clickEdit(data)"
              >
                <q-tooltip>
                  {{ t('collabNotes.tooltip.edit') }}
                </q-tooltip>
              </q-icon>
              <q-icon
                v-if="allowDelete"
                data-testid="delete-note"
                color="grey"
                name="delete_outline"
                size="sm"
                class="cursor-pointer"
                @click="clickDelete(data.uuid)"
              >
                <q-tooltip>
                  {{ t('collabNotes.tooltip.delete') }}
                </q-tooltip>
              </q-icon>
            </div>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="row">
          <div class="col-sm-12 col-md-7 q-pr-lg">
            <wysiwyg-editor-v2
              ref="editor"
              :editable="false"
              height="100%"
              :smaller-headers="true"
              @ready="onEditorReady"
            />
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="footer">
          <last-change
            :date="
              formatDateForTemplate({
                date: props.data.updatedAt,
                showTime: true,
              })
            "
            :editor-name="props.data.editor.name"
          />
        </q-card-section>
      </q-card>

      <q-separator />
    </c-page-section>
  </div>
</template>

<script lang="ts" setup>
import CPageSection from '@/components/_common/PageSection.vue';
import { hubClient } from '@tfpl/api-client';
import { useI18n } from 'vue-i18n';
import { formatDateForTemplate } from '@/utils';
import LastChange from '@/components/_common/LastChange.vue';
import WysiwygEditorV2 from '@/components/_common/WysiwygEditorV2.vue';
import { ref } from 'vue';
const { t } = useI18n();

/*****************************************************************************
 * PROPS
 ****************************************************************************/
const props = defineProps<{
  data: hubClient.CollaboratorNoteDto;
  allowEdit: boolean;
  allowDelete: boolean;
}>();

/*****************************************************************************
 * EMITS
 ****************************************************************************/
const emit = defineEmits<{
  (e: 'click:delete', uuid: string): void;
  (e: 'click:edit', note: hubClient.CollaboratorNoteDto): void;
}>();
const clickDelete = (uuid: string) => {
  emit('click:delete', uuid);
};

const clickEdit = (note: hubClient.CollaboratorNoteDto) => {
  emit('click:edit', note);
};
/*****************************************************************************
 * SETUP
 ****************************************************************************/

const editor = ref();

const onEditorReady = () => {
  editor.value.setHTML(props.data.note);
};
</script>
<style scoped lang="scss">
@import 'styles/app.variables.scss';
</style>
